// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.
import taskUsers from './project-checklist-task-users.js';

export default [
    {
        path: ':checklistId/checklist-tasks/new',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/project-checklist-task/new.vue'),
        name: 'project-management.project-checklist-tasks.create-checklist-task',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-tasks.create-project-checklist-task',
        },
    },
    {
        path: ':checklistId/checklist-tasks/:taskId',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/project-checklist-task/[id].vue'),
        name: 'project-management.project-checklist-tasks.view-checklist-task',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-tasks.view-project-checklist-tasks',
        },
        children: [...taskUsers],
    },
    {
        path: ':checklistId/checklist-tasks/:taskId/archive',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/archived-project-checklist-task/[id].vue'),
        name: 'project-management.project-checklist-tasks.view-archived-checklist-task',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-tasks.view-project-checklist-tasks',
        },
    },
    {
        path: ':checklistId/checklist-tasks/:taskId/bin',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/binned-project-checklist-task/[id].vue'),
        name: 'project-management.project-checklist-tasks.view-binned-checklist-task',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-tasks.view-project-checklist-tasks',
        },
    },
    {
        path: ':checklistId/checklist-tasks/:taskId/edit',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/project-checklist-task/[id]/edit.vue'),
        name: 'project-management.project-checklist-tasks.update-checklist-task',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-tasks.update-project-checklist-task',
        },
    },
];
